import {
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  ADD_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_SUCCESS,
  SET_EDITING_PERMISSION,
  CLEAR_EDITING_PERMISSION
} from '../../../../types/masters/users/permission/permissionTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingPermission: null,
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case FETCH_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.error };
    case ADD_PERMISSION_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_PERMISSION_SUCCESS:
      return {
        ...state,
        list: state.list.map(p => p.permission_id === action.payload.permission_id ? action.payload : p),
      };
    case DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        list: state.list.filter(p => p.permission_id !== action.payload),
      };
    case SET_EDITING_PERMISSION:
      return { ...state, editingPermission: action.payload };
    case CLEAR_EDITING_PERMISSION:
      return { ...state, editingPermission: null };
    default:
      return state;
  }
}
